import { type FC, type ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { EngagementOverviewHeader } from "src/layouts/Engagements/Overview/Index";
import "../../Overview/Overview.scss";
import "./CampaignFlow.scss";

interface CampaignPageLayoutProps {
  children: ReactNode;
  stepper?: ReactNode;
  className?: string;
  title?: string;
  subtitle?: string;
  stickyChrome?: boolean;
  onExit?: () => void;
}

const CampaignPageLayout: FC<CampaignPageLayoutProps> = ({
  children,
  stepper,
  className,
  title,
  subtitle,
  stickyChrome = false,
  onExit,
}) => {
  const { t } = useTranslation();

  return (
    <div
      className={[
        "campaign-flow",
        stickyChrome ? "campaign-flow--sticky" : "",
        className ?? "",
      ]
        .filter(Boolean)
        .join(" ")}
    >
      <div className="campaign-flow__top">
        <div className="campaign-flow__page-header">
          <EngagementOverviewHeader
            title={title ?? t("campaignFlow.createCampaignNew.title")}
            subtitle={subtitle ?? t("campaignFlow.createCampaignNew.subtitle")}
          />
          {onExit && (
            <button type="button" className="button button--outline" onClick={onExit}>
              {t("campaignFlow.common.exit")}
            </button>
          )}
        </div>
        {stepper && <div className="campaign-flow__stepper">{stepper}</div>}
      </div>
      <div className="campaign-flow__body">{children}</div>
    </div>
  );
};

export default CampaignPageLayout;
